import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <React.Fragment>
            <section className="footer bg-dark">
                <Container>
                    <Row>
                        <Col lg={4}>
                            <div className="footer-menu">
                                <h3 className="mb-4 text-uppercase text-white"><i className="mdi mdi-chart-donut-variant"></i> Larix</h3>
                                <p>The Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium eaque quae ab illo inventore veritatis et.</p>
                                <div className="text-white d-flex gap-1">
                                    <Link to="#facebook"><i className="mdi mdi-facebook facebook footer_mdi"></i></Link>
                                    <Link to="#twitter"><i className="mdi mdi-twitter twitter footer_mdi"></i></Link>
                                    <Link to="#google"><i className="mdi mdi-google google footer_mdi"></i></Link>
                                </div>
                            </div>
                        </Col>

                        <Col lg={2}>
                            <div className="footer-menu">
                                <h5 className="mb-4 text-uppercase">About</h5>
                                <ul className="text-muted list-unstyled">
                                    <li><Link to="#">About Us</Link></li>
                                    <li><Link to="#">Press</Link></li>
                                    <li><Link to="#">Job Opening</Link></li>
                                    <li><Link to="#">Term</Link></li>
                                    <li><Link to="#">Privacy</Link></li>
                                </ul>
                            </div>
                        </Col>

                        <Col lg={2}>
                            <div className="footer-menu">
                                <h5 className="mb-4 text-uppercase">Help Center</h5>
                                <ul className="text-muted list-unstyled">
                                    <li><Link to="#">Accounting</Link></li>
                                    <li><Link to="#">Billing</Link></li>
                                    <li><Link to="#">General Question</Link></li>
                                </ul>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="footer-menu">
                                <h5 className="mb-4 text-uppercase">Contact us</h5>
                                <p>The Nam eget dui Etiam rhoncus. Maecenas eget sem quam semper libero.</p>
                                <span className="footer-support">Support@abc.com</span>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12}>
                            <div className="text-center mt-5">
                                <p className="mb-0">{new Date().getFullYear()} © Larix.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
}

export default Footer;